<template>
  <div style="padding:15px">
    <Button type="success" @click="changeState" :disabled="state==1">开始启动生成</Button>
    <div style="max-width: 450px;padding-top:20px">
      <Alert v-if="state==0">当前视频/小红书分享海报/课程海报将于凌晨00:05分开始启动生成</Alert>
      <Alert v-if="state==1" type="warning">当前视频/小红书分享海报/课程海报正在生成中...<a @click="loadState">点击刷新状态</a></Alert>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      state: -1,
    }
  },
  methods: {
    loadState() {
      this.$Spin.show();
      let that = this;
      this.$axios.get('/api/xhs/getState').then(function (rs) {
        that.state = rs.data;
        that.$Spin.hide();
      });
    },
    changeState() {
      let that = this;
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要开始启动生成码，启动后不可终止',
        onOk: () => {
          this.$axios.get('/api/xhs/changeState?state=1').then(function (rs) {
            if(rs.data.success){
              that.state = 1;
              that.$Message.success(rs.data.msg);
            }else{
              that.$Message.error(rs.data.msg);
            }
          });
        },
      });
    }
  },
  created() {
    this.loadState();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/task/Task.vue